(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const closeSubnav = except => document.querySelectorAll('.nav-dropdown.is-open').forEach(node => {
    if (node === except) return;
    node.classList.remove('is-open');
    node.querySelector('[data-subnav-toggle]')?.setAttribute('aria-expanded', 'false');
  });
  function closeMobile(restore = false) {
    document.body.classList.remove('nav-open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded','false');
    closeSubnav();
    if (restore) document.querySelector('[data-menu-toggle]')?.focus();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (button?.matches('[data-menu-toggle]')) {
      const open = document.body.classList.toggle('nav-open');
      button.setAttribute('aria-expanded', String(open));
      if (open) document.querySelector('[data-menu-close]')?.focus();
    }
    if (button?.matches('[data-menu-close]')) closeMobile(true);
    if (button?.matches('[data-subnav-toggle]')) {
      const parent = button.closest('.nav-dropdown');
      const open = !parent.classList.contains('is-open');
      closeSubnav(parent);parent.classList.toggle('is-open',open);
      button.setAttribute('aria-expanded',String(open));
    }
    if (button?.matches('[data-category-group-toggle]')) {
      const open = button.closest('.taxonomy-menu__group').classList.toggle('is-open');
      button.setAttribute('aria-expanded',String(open));
    }
    if (button?.matches('[data-brand-slide]')) {
      const track = document.getElementById(button.dataset.brandSlider);
      track?.scrollBy({left:Number(button.dataset.brandSlide)*track.clientWidth*.75,behavior:reduce()?'auto':'smooth'});
    }
    if (button?.matches('[data-product-slide]')) {
      const track = document.getElementById(button.getAttribute('aria-controls'));
      track?.scrollBy({left:Number(button.dataset.productSlide)*track.clientWidth*.85,behavior:reduce()?'auto':'smooth'});
    }
    if(event.target.closest('.primary-nav a'))closeMobile();
    if(!event.target.closest('.nav-dropdown')&&!event.target.closest('[data-menu-toggle]'))closeSubnav();
  });
  document.addEventListener('focusout', event => {
    const dropdown = event.target.closest('.nav-dropdown');
    if (dropdown && !dropdown.contains(event.relatedTarget)) closeSubnav();
  });
  document.addEventListener('change',event=>{
    const form=event.target.closest('[data-adler-filter-form]');
    if(form&&event.target.name==='sort_by')form.requestSubmit();
  });
  document.addEventListener('click',event=>{
    const chosen=event.target.closest('.adler-collection__filter');
    document.querySelectorAll('.adler-collection__filter[open]').forEach(node=>{if(node!==chosen)node.open=false;});
  });
  document.addEventListener('keydown', event => {
    if(event.key==='Escape'){
      const filter=event.target.closest('.adler-collection__filter[open]');
      if(filter){filter.open=false;filter.querySelector('summary')?.focus();}
    }
    if (event.key === 'Escape') {
      if(document.body.classList.contains('nav-open')) closeMobile(true);
      else {
        const dropdown=event.target.closest('.nav-dropdown.is-open');
        closeSubnav();dropdown?.querySelector('[data-subnav-toggle]')?.focus();
      }
    }
    if (event.key === 'ArrowDown' && event.target.matches('.nav-category-link,[data-subnav-toggle]')) {
      event.preventDefault();
      const dropdown = event.target.closest('.nav-dropdown');
      closeSubnav(dropdown);
      dropdown.classList.add('is-open');
      dropdown.querySelector('[data-subnav-toggle]').setAttribute('aria-expanded', 'true');
      dropdown.querySelector('.mega-menu a')?.focus();
    }
    const track=event.target.closest('.shop-product-slider');
    if(track&&event.target===track&&['ArrowLeft','ArrowRight'].includes(event.key)){
      event.preventDefault();track.scrollBy({left:(event.key==='ArrowRight'?1:-1)*track.clientWidth*.85,behavior:'auto'});
    }
    if(event.key==='Tab'&&document.body.classList.contains('nav-open')){
      const nav=document.getElementById('primary-navigation');
      const focusable=[...nav.querySelectorAll('a,button')].filter(e=>e.getClientRects().length&&!e.disabled);
      const first=focusable[0],last=focusable.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
      if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    }
  });
  function init(){
    document.querySelectorAll('.nav-dropdown').forEach(dropdown=>{
      if(dropdown.dataset.adlerNavBound)return;
      dropdown.dataset.adlerNavBound='true';
      const canHover=()=>window.matchMedia('(min-width:1051px) and (hover:hover) and (pointer:fine)').matches;
      dropdown.addEventListener('pointerenter',()=>{
        if(!canHover())return;
        closeSubnav(dropdown);
        dropdown.classList.add('is-open');
        dropdown.querySelector('[data-subnav-toggle]')?.setAttribute('aria-expanded','true');
      });
      dropdown.addEventListener('pointerleave',()=>{
        if(canHover()&&!dropdown.contains(document.activeElement))closeSubnav();
      });
    });
    const stickyHeader=document.querySelector('[data-adler-sticky-header]');
    if(stickyHeader&&!stickyHeader.dataset.observed){
      stickyHeader.dataset.observed='true';
      const measure=()=>document.documentElement.style.setProperty('--adler-header-height',Math.ceil(stickyHeader.getBoundingClientRect().height)+'px');
      new ResizeObserver(measure).observe(stickyHeader);measure();
    }
    document.querySelectorAll('[data-adler-filter-panel]').forEach(panel=>{
      if(panel.dataset.bound)return;panel.dataset.bound='true';
      const mobile=window.matchMedia('(max-width:650px)');
      panel.open=!mobile.matches;
      mobile.addEventListener('change',()=>{panel.open=!mobile.matches;});
    });
    document.querySelectorAll('.shop-product-slider').forEach(track=>{
      if(track.dataset.adlerBound)return;track.dataset.adlerBound='true';
      const sync=()=>document.querySelectorAll('[data-product-slide]').forEach(button=>{
        if(button.getAttribute('aria-controls')!==track.id)return;
        button.disabled=Number(button.dataset.productSlide)<0?track.scrollLeft<=2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
      });track.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(track);sync();
    });
    const directory=document.querySelector('.adler-industry-directory');
    if(directory){
      const query=new URLSearchParams(location.search),industry=query.get('branche'),sector=query.get('unterbranche')||'';
      const panel=[...directory.querySelectorAll('[data-industry]')].find(p=>p.dataset.industry===industry&&p.dataset.sector===sector);
      if(panel){panel.hidden=false;directory.querySelector('[data-industry-heading]').textContent=panel.querySelector('h2').textContent;panel.scrollIntoView({block:'nearest'});}
    }
    if(location.hash){
      let id=location.hash.slice(1);
      try{id=decodeURIComponent(id);}catch{}
      const node=document.getElementById(id);if(node?.tagName==='DETAILS')node.open=true;
    }
  }
  window.addEventListener('resize',()=>{const toggle=document.querySelector('[data-menu-toggle]');if(toggle&&!toggle.getClientRects().length)closeMobile();},{passive:true});
  init();document.addEventListener('shopify:section:load',init);
})();
